import * as React from 'react';

import {
	Label,
	IBoxComponentProps,
	ILabelComponentProps,
	Box,
	IInputBoxComponentProps,
	IconButton,
	ActionsDropdown,
	ActionsDropdownItem,
	IInputContainerComponentProps,
} from '@moosend/mooskin';

export const FormLabel: React.FC<ILabelComponentProps> = (props) => {
	return <Label mb={15} {...props} />;
};

export const FormBox: React.FC<IBoxComponentProps> = (props) => {
	return <Box mb={20} {...props} />;
};

export function withDescription<P>(Component: React.FunctionComponent<P>) {
	return (props: P & { description?: string }) => {
		const [showDescription, setShowDescription] = React.useState(false);

		if (!props.description) return <Component {...props} />;

		return (
			<>
				<Box d="flex" align="center" noRender={['lg', 'md']}>
					<Component {...props} />
					<Box position="relative">
						<IconButton
							fontFamily="Mooskin Icons Outlined"
							fontSize={24}
							fontColor="backgroundColors.primary3"
							children="info"
							onClick={() => setShowDescription(true)}
							cursor="help"
							ml={10}
						/>
						<ActionsDropdown isOpen={showDescription} onClose={() => setShowDescription(false)}>
							<ActionsDropdownItem whiteSpace="unset">{props.description}</ActionsDropdownItem>
						</ActionsDropdown>
					</Box>
				</Box>
				<Box noRender={['xs', 'sm']}>
					<Component {...props} />
				</Box>
			</>
		);
	};
}
